import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  maxWidth: '90vw',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
};

const ValidationModal = ({ 
  open, 
  onClose, 
  currentEntryErrors 
}) => (
  <Modal open={open} onClose={onClose}>
    <Box sx={modalStyle}>
      <Typography variant="h6" gutterBottom>
        Validation Errors
      </Typography>
      
      <Box sx={{ maxHeight: "60vh", overflow: "auto" }}>
        {currentEntryErrors.length > 0 ? (
          currentEntryErrors.map((error, index) => (
            <Box
              key={index}
              sx={{
                mb: 2,
                pb: 2,
                borderBottom: "1px solid #eee",
              }}
            >
              {error.commandNo && (
                <Typography fontWeight="bold">
                  Command No: {error.commandNo}
                </Typography>
              )}

              {/* Display the error field (HTML content) */}
              {error.error && (
                <Box
                  dangerouslySetInnerHTML={{ __html: error.error }}
                  sx={{
                    color: "text.primary",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                    "& span": {
                      color: "text.primary !important",
                      fontWeight: "normal !important",
                      textDecoration: "none !important",
                    },
                  }}
                />
              )}

              {/* Display the message field (plain text) */}
              {error.message && (
                <Typography sx={{ mt: 1, color: "text.primary" }}>
                  {error.message}
                </Typography>
              )}
            </Box>
          ))
        ) : (
          <Typography>No validation errors found</Typography>
        )}
      </Box>
      
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={onClose}
      >
        Close
      </Button>
    </Box>
  </Modal>
);

export default ValidationModal;
